import { render } from "./CxContactUs.vue?vue&type=template&id=58934f36&scoped=true"
import script from "./CxContactUs.vue?vue&type=script&lang=js"
export * from "./CxContactUs.vue?vue&type=script&lang=js"

import "./CxContactUs.vue?vue&type=style&index=0&id=58934f36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58934f36"]])

export default __exports__